export default "__VITE_ASSET__b6e12e5a__"